import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { Checkbox } from "components/checkbox";
import { CustomModal } from "components/custom-modal";
import DynamicTable from "components/dynamic-table";
import { Column } from "components/dynamic-table/types";
import { useApplicationContext } from "contexts/ApplicationContext";
import { use3cPlusContext } from "contexts/Context3cPlus";
import { useEffect, useState } from "react";
import { useRouter } from "routes/router-control/use-router";
import {
  enterCampaign,
  listCampaigns,
  logoutCampaign,
} from "services/api3cplus";
import { useEventListener, makeEvent } from "services/events";
import { Toast } from "components/toast";

let modalHasAlreadyBeenOpened = false;

export function Modal3cPlusCampanhas() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingEnter, setIsLoadingEnter] = useState(false);
  const [selectedCampanha, setSelectedCampanha] = useState<null | {
    id: number;
    name: string;
  }>(null);
  const [campanhas, setCampanhas] = useState<{ name: string; value: string }[]>(
    []
  );
  const { user } = useApplicationContext();
  const { dispatch3cPlus, controls3cPlus } = use3cPlusContext();

  const { pathname } = useRouter();

  const onOpen = () => {
    setIsOpen(true);
    modalHasAlreadyBeenOpened = true;
    handleSubmit();
  };

  const onClose = () => {
    setIsOpen(false);
    setSelectedCampanha(null);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const data = await listCampaigns();
      setCampanhas(data.data);
    } catch (e) {
      Toast({ title: "Erro ao obter campanhas", status: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEnter = async (tentouNovamente?: boolean) => {
    setIsLoadingEnter(true);
    try {
      await enterCampaign(selectedCampanha?.id!, "dialer");
      const campanhaName = selectedCampanha!.name;
      dispatch3cPlus({ type: "campaignLogin", payload: campanhaName });
      onClose();
    } catch (e: any) {
      const errorMessage = e?.response?.data?.detail;
      if (errorMessage == "O agente já está logado" && !tentouNovamente) {
        await logoutCampaign();
        await handleEnter(true);
      } else {
        Toast({ title: errorMessage ?? "Erro ao entrar", status: "error" });
      }
    } finally {
      setIsLoadingEnter(false);
    }
  };

  useEventListener("openModal3cPlusCampanhas", onOpen);

  useEffect(() => {
    if (
      user.userData.enabled3cplus &&
      !controls3cPlus.campaign.isLogged &&
      !modalHasAlreadyBeenOpened &&
      ["/atendimentos", "/atendimento-cliente-page"].includes(pathname)
    )
      onOpen();
  }, [pathname]);

  const modalFooter = (
    <>
      <Button
        onClick={() => handleEnter()}
        isDisabled={selectedCampanha === null}
        leftIcon={<CheckIcon />}
        isLoading={isLoadingEnter}
        loadingText="Entrando"
      >
        Entrar
      </Button>
      <Button
        variant="outline"
        onClick={onClose}
        leftIcon={<CloseIcon w="12px" h="12px" />}
      >
        Cancelar
      </Button>
    </>
  );

  const columns: Column[] = [
    {
      name: "Nome da Campanha",
      render: (row) => {
        return row.name;
      },
    },
    {
      name: "",
      render: (row) => {
        const isSelected = selectedCampanha?.id === row.id;
        return (
          <Checkbox
            isChecked={isSelected}
            onChange={() => {
              setSelectedCampanha(
                isSelected ? null : { id: row.id, name: row.name }
              );
            }}
          />
        );
      },
    },
  ];

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Selecione uma campanha para logar"
      modalFooter={modalFooter}
      size="2xl"
      isLoading={isLoading}
    >
      <DynamicTable
        columns={columns}
        rows={campanhas}
        pageSize={6}
        onClickRow={(row) =>
          setSelectedCampanha(
            selectedCampanha?.id === row.id
              ? null
              : { id: row.id, name: row.name }
          )
        }
      />
    </CustomModal>
  );
}

export const openModal3cPlusCampanhas = () =>
  makeEvent("openModal3cPlusCampanhas");
